var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('Header')],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('MenuList')],1),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('div',{staticStyle:{"margin-left":"20px","margin-bottom":"40px"}},[_c('button',{on:{"click":_vm.copy}},[_vm._v("测试公众号复制")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0244aee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test_copy.vue
// module id = null
// module chunks = 